export const API_GET_COMPETITORS = "API_GET_COMPETITORS"
export const RESET_COMPETITORS = "RESET_COMPETITORS"
export const API_GET_COMPETITOR_PICKUP_POINTS = "API_GET_COMPETITOR_PICKUP_POINTS"
export const REMOVE_COMPETITOR_PICKUP_POINTS = "REMOVE_COMPETITOR_PICKUP_POINTS"
